// Auth for Login and Registration
export const REGISTER_START = 'REGISTER_SUCCESS';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const CLIENT_LOADED = 'CLIENT_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';

// Clients
export const GET_CLIENTS_START = 'GET_CLIENTS_START';
export const GET_CLIENTS_SUCCESS = 'GET_CLIENTS_SUCCESS';
export const GET_CLIENTS_FAILURE = 'GET_CLIENTS_FAILURE';
export const ADD_CLIENT = 'ADD_CLIENT';
export const DELETE_CLIENT = 'DELETE_CLIENT';
export const CLIENTS_ERROR = 'CLIENTS_ERROR';
export const UPDATE_METRIC_START = 'UPDATE_METRIC_START';
export const UPDATE_METRIC_SUCCESS = 'UPDATE_METRIC_SUCCESS';
export const UPDATE_METRIC_FAILURE = 'UPDATE_METRIC_FAILURE';

export const GET_METRICS_START = 'GET_METRICS_START';
export const GET_METRICS_SUCCESS = 'GET_METRICS_SUCCESS';
export const GET_METRICS_FAILURE = 'GET_METRICS_FAILURE';

// Coach

export const GET_RECORDS_START = 'GET_RECORDS_START';
export const GET_RECORDS_SUCCESS = 'GET_RECORDS_SUCCESS';
export const GET_RECORDS_FAILURE = 'GET_RECORDS_FAILURE';

export const GET_TEXT_START = 'GET_TEXTS_START';
export const GET_TEXT_SUCCESS = 'GET_TEXTS_SUCCESS';
export const ADD_TEXT_START = 'ADD_TEXTS_START';
export const ADD_TEXT_SUCCESS = 'ADD_TEXTS_SUCCESS';
export const GET_CHECKIN = 'GET_CHECKIN';
export const GET_GOALS = 'GET_GOALS';

// coach schedule messages
export const ADD_SCHEDULE_MESSAGE_START = 'ADD_SCHEDULE_MESSAGE_START';
export const ADD_SCHEDULE_MESSAGE_SUCCESS = 'ADD_SCHEDULE_MESSAGE_SUCCESS';
export const GET_SCHEDULE_MESSAGE_START = 'GET_SCHEDULE_MESSAGE_START';
export const GET_SCHEDULE_MESSAGE_SUCCESS = 'GET_SCHEDULE_MESSAGE_SUCCESS';
export const DELETE_SCHEDULE_MESSAGE_START = 'DELETE_SCHEDULE_MESSAGE_START';
export const DELETE_SCHEDULE_MESSAGE_SUCCESS =
    'DELETE_SCHEDULE_MESSAGE_SUCCESS';
export const UPDATE_SCHEDULE_MESSAGE_START = 'UPDATE_SCHEDULE_MESSAGE_START';
export const UPDATE_SCHEDULE_MESSAGE_SUCCESS =
    'UPDATE_SCHEDULE_MESSAGE_SUCCESS';

export const COACH_ERROR = 'COACH_ERROR';
